<script lang="ts">
    import { faList, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import Fa from 'svelte-fa'
    import type { ZChatContactEntity, ZChatMessageEntity } from './zchat'
    import ZinputGroup from '../zinput-group.svelte'
    import Zinput from '../zinput.svelte'
    import Zbutton from '../zbutton.svelte'
    import ZchatMessage from './zchat-message.svelte'

    const dispatch = createEventDispatcher()

    let btnSend

    export let contacts: ZChatContactEntity[] = []

    let contact: ZChatContactEntity = null

    export async function setChat(id: string) {
        contact = null
        await tick()
        contact = contacts.find((c) => c.id === id)
        await tick()
        if (btnSend) btnSend.focus()
    }

    function onOpen(ev) {
        dispatch('open', ev.detail)
    }
</script>

<div class="chat-container">
    <div class="chat-contacts">
        {#each contacts as item}
            <div class="-contact" class:-contact-active={item.id === contact?.id} on:click={() => setChat(item.id)}>
                <div class="contact-photo">
                    <img src={item.photo} alt={item.name} />
                </div>
                <div class="contact-info">
                    <div class="contact-name">{item.name}</div>
                    <div class="contact-phone">{item.label}</div>
                </div>
            </div>
        {/each}
    </div>
    <div class="chat">
        {#if contact}
            <div class="chat-header">
                <div class="-contact">
                    <div class="contact-photo">
                        <img src={contact.photo} alt={contact.name} />
                    </div>
                    <div class="contact-info">
                        <div class="contact-name">{contact.name}</div>
                        <div class="contact-phone">{contact.status || ''}</div>
                    </div>
                </div>
            </div>
            <div class="chat-body">
                {#each contact.messages as message}
                    <ZchatMessage on:open={onOpen} {message}></ZchatMessage>
                {/each}
            </div>
            {#if contact.type === 'chat'}
                <div class="chat-footer">
                    <ZinputGroup>
                        <Zinput bind:this={btnSend} label="Mensagem"></Zinput>
                        <Zbutton icon={faPaperPlane}></Zbutton>
                    </ZinputGroup>
                </div>
            {/if}
        {/if}
    </div>
</div>
